import type { StrapiMediaBlock } from "../types";

interface MediaBlockProps {
  block: StrapiMediaBlock;
}

export const MediaBlock = ({ block }: MediaBlockProps) => {
  if (!block.file) {
    return null;
  }
  return (
    <div className="flex flex-col gap-2">
      <img
        src={block.file.url}
        alt={block.file.alternativeText || ""}
        className="w-full h-auto rounded-lg"
      />
      {block.file.caption && (
        <p className="text-xs text-muted-foreground text-center">
          {block.file.caption}
        </p>
      )}
    </div>
  );
};
